import React from "react";
import Header from "./Header";
import EntityList from "../entities/EntityList";

export default function LayoutEntities() {
  return (
    <>
      <Header />
      <EntityList />
    </>
  );
}
